/* eslint-disable no-restricted-imports */
import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  Form,
  Row,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { useFormik } from "formik";
import config from "../../../../config/config";
import Rating from "@material-ui/lab/Rating";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    "& > * + *": {
      marginTop: theme.spacing(1),
    },
  },
}));

export const NuovaValutazione = (props) => {
  /*eslint-disable */
  const [fields, setFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState({});

  const GetColumnFields = () => {
    setLoading(true);
    const adminOptions = {
      headers: {
        Authorization:
          "271c4d716fcf0e9555b51cffed666b4321f98f7f8bbeb9ae8bfc67752b4db8a2",
      },
      method: "POST",
      body: JSON.stringify({
        selectedUser: props.id,
        idRole: props.user.id_role,
        idUser: props.user.id,
        idOrganization: props.user.id_organization,
        page: "valutazione",
      }),
    };
    fetch(config.apiUrl + "obiettivi/GetColumnSupervisor.php", adminOptions)
      .then((response) => response.json())
      .then((data) => setFields(data))
      .then(() => {
        var object = {};
        fields.forEach((element) => {
          object[element.name] = 0;
        });
        setInitialValues(object);
      })
      .then(() => setLoading(false));
  };

  useEffect(() => {
    GetColumnFields();
  }, [props.show]);

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      const adminOptions = {
        headers: {
          Authorization:
            "271c4d716fcf0e9555b51cffed666b4321f98f7f8bbeb9ae8bfc67752b4db8a2",
        },
        method: "POST",
        body: JSON.stringify({
          selectedUser: props.id,
          type:"valutazione",
          idRole: props.user.id_role,
          idUser: props.user.id,
          idOrganization: props.user.id_organization,
          values: values,
        }),
      };
      fetch(config.apiUrl + "obiettivi/ValutaDipendente.php", adminOptions);
      props.setCount(props.count + 1);
      props.handleClose();
      props.handleOpenRiepilogo(props.id, props.nomeDipendente);
    },
  });

  const classes = useStyles();

  return (
    <>
      <Modal show={props.show} onHide={props.handleClose}>
        <Modal.Header>
          <Modal.Title>Valuta {props.nomeDipendente}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!loading ? (
            <Form>
              <Row>
                <div className="col-12 mb-3"></div>
                {fields.map((e, key) => {
                  return (
                    <div className="col-6">
                      <Box
                        className={classes.root}
                        component="fieldset"
                        mb={3}
                        borderColor="transparent"
                      >
                        <Typography component="legend">
                          {e.title}
                          {e.description !== false ? (
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              placement="right"
                              overlay={
                                <Popover id={`popover-positioned-top`}>
                                  <Popover.Content>
                                    {e.description}
                                  </Popover.Content>
                                </Popover>
                              }
                            >
                              <i
                                color="info"
                                className="far fa-question-circle fa-sm ml-3"
                              ></i>
                            </OverlayTrigger>
                          ) : null}
                        </Typography>
                        <Rating
                          size="large"
                          key={key}
                          name={e.name}
                          onChange={formik.handleChange}
                          precision={0.5}
                        />
                      </Box>
                    </div>
                  );
                })}
                <div className="col-12">
                  {fields !== [] ? (
                    <label className="text-muted">
                      Ricorda che puoi impostare altri campi nelle impostazioni
                      valutazione.
                    </label>
                  ) : (
                    <label className="text-muted">
                      Prima di valutare un dipendente imposta i campi nelle
                      impostazioni valutazione.
                    </label>
                  )}
                </div>
              </Row>
            </Form>
          ) : (
            <div className="col-12">
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ display: "block !important" }}>
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="top"
            overlay={
              <Popover id={`popover-positioned-top`}>
                <Popover.Content>Se è già stata effettuata una valutazione questo mese, aggiornerai l'ultima</Popover.Content>
              </Popover>
            }
          >
            <Button onClick={formik.handleSubmit} variant="primary" size="sm">
              Valuta
            </Button>
          </OverlayTrigger>

          <Button variant="danger" size="sm" onClick={props.handleClose}>
            Annulla
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
